import React from "react";
import { Helmet } from "react-helmet";
import { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { FaMapMarkerAlt, FaPhoneAlt, FaRegMap } from "react-icons/fa";
import { MdMarkEmailUnread } from "react-icons/md";
import TopBanner from "../../components/designTab/TopBanner";

const Contact = () => {
  let [cname, setCname] = useState("");
  let [cemail, setCemail] = useState("");
  let [cmessage, setCmessage] = useState("");
  let [successMsg, setSuccessMsg] = useState("");
  // ========== set Error Messages start here ==========
  let [errcname, setErrcname] = useState("");
  let [errcemail, setErrcemail] = useState("");
  let [errcmessage, setErrcmessage] = useState("");
  // ========== set Error Messages end here ============
  // ========== Email Validation start here ==============
  const emailValidation = () => {
    return String(cemail)
      .toLocaleLowerCase()
      .match(/^\w+([-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+$/);
  };
  // ========== Email Validation end here ================

  const handleMsgSubmit = (e) => {
    e.preventDefault();
    if (cname === "") {
      setErrcname("Your name is required!");
    } else if (cemail === "") {
      setErrcemail("Provide Email is required!");
    } else if (!emailValidation(cemail)) {
      setErrcemail("Provide a Valid Email!");
    } else if (cmessage === "") {
      setErrcmessage("Your message is required!");
    } else {
      axios.post("https://getform.io/f/bf5b529d-dd07-4257-a891-ea9c539ededa", {
        name: cname,
        email: cemail,
        message: cmessage,
      });
      setSuccessMsg(
        `Hello dear ${cname}, We received your message successfully. You will receive further details in your email at ${cemail} and our team member will contact with you shortly. Thank you for your time.`
      );
      setErrcname("");
      setErrcemail("");
      setErrcmessage("");
      setCname("");
      setCemail("");
      setCmessage("");
    }
  };
  return (
    <div className="w-full h-auto">
      <Helmet>
        <title>Contact Us - EduCare English Learning Academy</title>
      </Helmet>
      <TopBanner titleText="Contact Us" />
      <div className="max-w-screen-2xl py-20 mx-auto px-4 mdl:px-10 lg:px-20 flex flex-col gap-10 mdl:gap-0 mdl:flex-row items-center">
        <div className="w-full mdl:w-1/2 flex flex-col gap-10">
          <div className="flex w-full flex-row gap-4">
            <div>
              <span className="w-14 h-14 inline-flex items-center justify-center text-white rounded-full bg-primeColor">
                <FaMapMarkerAlt size={35} />
              </span>
            </div>
            <div className="flex flex-col gap-2">
              <h2 className="font-titleFont text-2xl font-medium">Address</h2>
              <p className="font-bodyFont text-base text-gray-600">
                285/K, Sajid Tower, <br />
                Joydebpur Bus Stand Road, Gazipur.
                <br />
                Division - Dhaka <br />
                Bangladesh.
              </p>
            </div>
          </div>
          <div className="flex flex-row gap-4">
            <div>
              <span className="w-14 h-14 inline-flex items-center justify-center text-white rounded-full bg-primeColor">
                <FaPhoneAlt size={35} />
              </span>
            </div>
            <div className="flex flex-col gap-2">
              <h2 className="font-titleFont text-2xl font-medium">Phone</h2>
              <p className="font-bodyFont text-base text-gray-600">
                +880 1975-598780
              </p>
            </div>
          </div>
          <div className="flex flex-row gap-4">
            <div>
              <span className="w-14 h-14 inline-flex items-center justify-center text-white rounded-full bg-primeColor">
                <MdMarkEmailUnread size={35} />
              </span>
            </div>
            <div className="flex flex-col gap-2">
              <h2 className="font-titleFont text-2xl font-medium">Email</h2>
              <p className="font-bodyFont text-base text-gray-600 hover:text-primeColor font-medium duration-300">
                <a href="mailto:query.educare@gmail.com">
                  query.educare@gmail.com
                </a>
              </p>
            </div>
          </div>
          <div className="flex flex-row gap-4">
            <div>
              <span className="w-14 h-14 inline-flex items-center justify-center text-white rounded-full bg-primeColor">
                <FaRegMap size={35} />
              </span>
            </div>
            <div className="flex flex-col gap-2">
              <h2 className="font-titleFont text-2xl font-medium">
                Our Location
              </h2>
              <p className="font-bodyFont text-base text-gray-600 hover:text-primeColor font-medium duration-300">
                To find us in Google Map please{" "}
                <a
                  href="https://www.google.com/maps/place/Educare+English+Learning+Academy/@23.9990817,90.4177853,17z/data=!4m12!1m6!3m5!1s0x3755dba4bfae5c99:0x6c5953dba5746681!2sEducare+English+Learning+Academy!8m2!3d23.9989016!4d90.4162457!3m4!1s0x3755dba4bfae5c99:0x6c5953dba5746681!8m2!3d23.9989016!4d90.4162457"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span className="text-base text-primeColor font-semibold underline underline-offset-2 decoration-[1px] hover:text-darkPink duration-300">
                    click here.
                  </span>
                </a>
              </p>
            </div>
          </div>
        </div>
        {/* ============================================================ 
                            Contact Form start here 
          ==============================================================*/}
        <div className="w-full mdl:w-1/2">
          {successMsg ? (
            <div className="w-full bg-darkPink p-6 text-white rounded-md">
              <motion.p
                initial={{ x: 50, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{
                  delay: 0.2,
                  x: { type: "spring", stiffness: 60 },
                  opacity: { duration: 1 },
                  ease: "easeIn",
                  duration: 1,
                }}
                className="font-titleFont text-lg font-semibold"
              >
                {successMsg}
              </motion.p>
            </div>
          ) : (
            <form
              id="form"
              action="https://getform.io/f/fb9d1b74-60fe-4058-98a2-f9b4b1032ea5"
              method="POST"
              className="shadow-xl w-full p-6 mdl:p-8 lg:p-16 shadow-primeColor"
            >
              <div>
                <p className="font-titleFont text-3xl mb-6 text-primeColor font-semibold">
                  Send Message
                </p>
              </div>
              <div className="w-full font-bodyFont flex flex-col gap-6">
                <input
                  onChange={(e) => setCname(e.target.value)}
                  name="name"
                  value={cname}
                  className="w-full text-lg border-b-[1px] border-b-gray-600 outline-none placeholder:text-[16px] pb-1 pt-6 placeholder:translate-y-0 focus:placeholder:-translate-y-6 focus:placeholder:text-sm focus:placeholder:text-primeColor shadow-lg px-4 "
                  type="text"
                  placeholder="Full Name"
                />
                {errcname ? (
                  <p className="text-red-400 px-3 bg-green-100 font-titleFont text-lg font-semibold tracking-wide rounded-sm animate-bounce">
                    {errcname}
                  </p>
                ) : (
                  ""
                )}
                <input
                  onChange={(e) => setCemail(e.target.value)}
                  name="email"
                  value={cemail}
                  className="w-full text-lg border-b-[1px] border-b-gray-600 outline-none placeholder:text-[16px] pb-1 pt-6 placeholder:translate-y-0 focus:placeholder:-translate-y-6 focus:placeholder:text-sm focus:placeholder:text-primeColor shadow-lg px-4 "
                  type="email"
                  placeholder="Enter your Email"
                />
                {errcemail ? (
                  <p className="text-red-400 px-3 bg-green-100 font-titleFont text-lg font-semibold tracking-wide rounded-sm animate-bounce">
                    {errcemail}
                  </p>
                ) : (
                  ""
                )}
                <textarea
                  onChange={(e) => setCmessage(e.target.value)}
                  name="message"
                  value={cmessage}
                  rows={4}
                  className="w-full text-lg border-b-[1px] border-b-gray-600 outline-none placeholder:text-[16px] pb-1 pt-6 placeholder:translate-y-0 focus:placeholder:-translate-y-6 focus:placeholder:text-sm focus:placeholder:text-primeColor shadow-lg px-4 resize-none"
                  type="email"
                  placeholder="Enter your Messages"
                />
                {errcmessage ? (
                  <p className="text-red-400 px-3 bg-green-100 font-titleFont text-lg font-semibold tracking-wide rounded-sm animate-bounce">
                    {errcmessage}
                  </p>
                ) : (
                  ""
                )}
                <button
                  onClick={handleMsgSubmit}
                  className="w-36 h-10 rounded-md mt-5 bg-primeColor text-white text-xl font-titleFont font-medium hover:bg-darkPink duration-500 shadow-lg hover:shadow-primeColor shadow-darkPink"
                >
                  Submit
                </button>
              </div>
            </form>
          )}
          {/* ============================================================ 
                            Contact Form end here 
          ==============================================================*/}
        </div>
      </div>
    </div>
  );
};

export default Contact;
